import type { Badge } from '../LibraryDeps'

interface Props {
  badges: Badge[]
  /** Show at most this many, then "+N" (all of them in the tooltip). */
  max?: number
  /** Phone tiles: coloured dots instead of named chips. */
  dots?: boolean
  className?: string
}

/** An item's Badges as small coloured chips (or dots), in catalog order. */
export function BadgeChips({ badges, max = badges.length, dots = false, className = '' }: Props) {
  if (!badges.length) return null
  const shown = badges.slice(0, max)
  const more = badges.length - shown.length
  const all = badges.map((b) => b.name).join(', ')
  if (dots) {
    return (
      <span className={`lib-badge-dots ${className}`} title={all} aria-label={all}>
        {shown.map((b) => (
          <span key={b.id} className="lib-badge-dot" data-c={b.color} />
        ))}
      </span>
    )
  }
  return (
    <span className={`lib-badges ${className}`} title={more ? all : undefined}>
      {shown.map((b) => (
        <span key={b.id} className="lib-badge" data-c={b.color} title={b.name}>
          {b.name}
        </span>
      ))}
      {more > 0 && <span className="lib-badge lib-badge--more">+{more}</span>}
    </span>
  )
}
